<template>
  <div class="dialog-scroll">
    <div class="viewable-area-style">
      <el-dialog
        class="search-popup"
        :show-close="false"
        :visible.sync="dialogVisible"
        :before-close="handleDialogClose">

        <div class="header-style">
          <div class="title-style">
            Outlookリソースを追加
          </div>
          <SpSmartButton class="cancel-button click-item" @click="cancel">
            キャンセル
          </SpSmartButton>
        </div>
        <div class="flow">
          <div style="color: #529AA4;">
            対象のエリアを選択
          </div>
          <div>
            <img class="rightArrow" src="@/assets/icon/rightArrow.svg"  alt="">
          </div>
          <div>
            連携するリソースを選択
          </div>
          <div>
            <img class="rightArrow" src="@/assets/icon/rightArrow.svg"  alt="">
          </div>
          <div>
            完了
          </div>
        </div>
        <el-form
          style="margin-top: 34px;"
          @submit.native.prevent
          :model="query"
          ref="selectMeetingRoomForm" >
          <el-row :gutter="16">
            <el-col class="col" style="display: flex;">
              <el-form-item style="width: 160px !important; margin-right: 8px;">
                <el-select
                  class="el-select-size"
                  placeholder="すべてのオーナー"
                  v-model="query.ownerId"
                  @change="changeOwner"
                >
                  <el-option
                    v-for="item in ownerList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="width: 160px !important; margin-right: 8px;">
                <el-select
                  class="el-select-size"
                  placeholder="すべてのビル"
                  :disabled="query.ownerId == null || query.ownerId == ''"
                  v-model="query.buildingId"
                  @change="changeBuild"
                >
                  <el-option
                    v-for="item in buildingList"
                    :key="item.buildingId"
                    :label="item.buildingName"
                    :value="item.buildingId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="width: 160px !important; margin-right: 8px;">
                <el-select
                  class="el-select-size"
                  placeholder="すべてのフロア"
                  :disabled="query.buildingId == null || query.buildingId == ''"
                  v-model="query.floorId"
                  @change="changeFloor"
                >
                  <el-option
                    v-for="item in filterFloorList"
                    :key="item.floorId"
                    :label="item.floorName"
                    :value="item.floorId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="areaName" style="width: 324px !important;">
                <el-input
                  class="input-class"
                  maxlength="50"
                  size="small"
                  placeholder="エリア名"
                  v-model="query.areaName">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 検索結果 START -->
        <div class="search-common">
          <el-table show-header :data="filterSearchResult">
          <!--  オーナー名 -->
            <el-table-column
              class-name="col-4"
              prop="ownerName"
              label="オーナー名"
            />
            <!--  ビル名 -->
            <el-table-column
              class-name="col-4"
              prop="buildingName"
              :label="$t('label.system.meetingRoom.search.result.buildingName')"
            />
            <!--  フロア名 -->
            <el-table-column
              class-name="col-4"
              prop="floorName"
              :label="$t('label.system.meetingRoom.search.result.floorName')"
            />
            <!--  エリア名 -->
            <el-table-column
              class-name="col-4"
              prop="areaName"
              :label="$t('label.system.meetingRoom.search.result.areaName')"
            />

            <el-table-column class-name="col-4">
              <div slot-scope="scope" class="detail-button with-100">
                <sp-smart-button @click="selectArea(scope.row)" class="detail-button btn-cancel button-width-100">
                  {{ $t("button.common.select") }}
                </sp-smart-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <!-- 検索結果 END -->

      </el-dialog>

      <outlook-Resource-add-popup
        :visible.sync="outlookResourceAddFlg"
        :areaInfo="selectedArea"
        :orgIdParam="ownerId"
        @outlook-save="onSave"
      />
    </div>

  </div>
</template>

<script>
import SpSmartButton from "@/components/common/sp-smart-button"
import SystemManageApi from "@/api/SystemManageApi"
import errorCodeMsg from "@/utils/error-code-msg"
import OutlookResourceAddPopup from '@/components/system/popup/outlookResourceAddPopup'


export default {
  components: {
    SpSmartButton,
    OutlookResourceAddPopup
  },
  props: {
    visible: Boolean,
    orgId: String
  },
  data: function () {
    return {
      selectedArea:{},
      outlookResourceAddFlg: false,
      ownerId: null,
      searchResultShowFlag: true,
      dialogVisible: this.visible,
      showSelectFloorDialog: false,
      query: {
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floorId: null,
        floor: null,
        areaName: null,
        pageId: null,
      },
      buildingList: [],
      floorList: [],
      ownerList: [],
      searchResult: [],
      filterFloorList: [],
      filterAreaList: [],
      filterSearchResult: [],
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if(this.orgId !== undefined && this.orgId !== null) {
        this.ownerId = this.orgId;
      }
      this.getOwnerSearch();
    },
    "query.areaName": {
      handler(newVal, oldVal) {
        this.filterSearchResult = this.searchResult

        if (!this.$IsNullOrEmpty(this.query.ownerId)) {
          this.filterSearchResult = this.filterSearchResult.filter(item => item.ownerId == this.query.ownerId)
        }

        if (!this.$IsNullOrEmpty(this.query.buildingId)) {
          this.filterSearchResult = this.filterSearchResult.filter(item => item.buildingId == this.query.buildingId)
        }

        if (!this.$IsNullOrEmpty(this.query.floorId)) {
          this.filterSearchResult = this.filterSearchResult.filter(item => item.floorId == this.query.floorId)
        }

        if (newVal != oldVal) {
          this.filterSearchResult = this.filterSearchResult.filter(item => item.areaName.indexOf(newVal) > -1)
        }
      }
    },

  },
  methods: {
    changeBuild(val){
      this.query.buildingId = this.$IsNullOrEmpty(val) ? null : val
      this.query.floorId = null
      this.query.areaName = null
      this.getFloorSearch()
      this.loadData()
    },
    changeFloor(val){
      this.query.floorId = this.$IsNullOrEmpty(val) ? null : val
      this.query.areaName = null
      this.loadData()
    },
    changeOwner(val){
      this.query.ownerId = this.$IsNullOrEmpty(val) ? null : val
      this.query.buildingId = null
      this.query.floorId = null
      this.query.areaName = null
      this.getBuildingSearch()
      this.loadData()
    },
    selectArea(item){
      this.selectedArea = item;
      this.outlookResourceAddFlg = true;
    },
    onSave(){
      this.handleDialogClose();
      this.$emit('outlook-save');
    },
    getBuildingSearch(){
      let req = {
          ownerId: this.query.ownerId,
          pageSize: 999,
          pageNumber: 1,
          funcCode: "130100"
        }

      SystemManageApi.searchBuilding(req)
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        if ("Success" == data.statusCode) {
          this.buildingList = [{buildingId: null, buildingName: ""}]
          for (let bodys of data.body.body) {
            this.buildingList.push({
              buildingId: bodys.buildingId,
              buildingName: bodys.buildingName,
            })
          }

          this.loadData()
        }
      })
    },
    getFloorSearch(){
      SystemManageApi.searchFloor({
        ownerId: this.query.ownerId,
        buildingId: this.query.buildingId,
        funcCode: "130100",
        pageSize: 999,
        pageNumber: 1,
      })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          this.floorList = [{buildingId: null, buildingName: "", floorId:null, floorName: ""}];
          if (data.body.body.length > 0) {
            for (let bodys of data.body.body) {
              this.floorList.push({
                buildingId: bodys.buildingId,
                buildingName: bodys.buildingName,
                floorId: bodys.floorId,
                floorName: bodys.floorName,
              });
            }
          }

          this.filterFloorList = this.floorList
        })
    },
    getOwnerSearch(){
       SystemManageApi.searchOwner({
          ownerId: null,
          ownerName: null,
          ownerExId: null,
          funcCode: "130100",
          pageSize: 999,
          pageNumber: 1,
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({data}) => {
          this.ownerList = [{id: null, name: ""}];
          if (data.body.body.length > 0) {
            this.ownerList.push(...data.body.body);
          }

        }).finally(() => {
        this.loadData();
        });
    },
    loadData(){
      let query = {}
      if (this.$IsOwnerManager()) {
        query = {
          ownerId: this.query.ownerId,
          buildingId: this.query.buildingId,
          floorId: this.query.floorId,
          ownerOnlyAreaFlag: true,
          funcCode: "130100",
          pageSize: 999,
          pageNumber: 1,
        }
      } else {
        query = {
          ownerId: this.query.ownerId,
          buildingId: this.query.buildingId,
          floorId: this.query.floorId,
          funcCode: "130100",
          pageSize: 999,
          pageNumber: 1,
        }
      }
      SystemManageApi.searchArea(query)
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        this.searchResult = []
        if (data.body.body.length > 0) {
          this.searchResult.push(...data.body.body);
        }

        this.filterSearchResult = this.searchResult
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
    },
    cancel () {
      this.handleDialogClose()
    },
    // Dialog閉じる
    handleDialogClose () {
      this.ownerList = []
      this.buildingList = []
      this.floorList = []
      this.searchResult = []
      this.filterFloorList = []
      this.filterAreaList = []
      this.filterSearchResult = []
      this.dialogVisible = false
      this.query = {
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floorId: null,
        floor: null,
        areaName: null,
        pageId: null,
      }
      this.$emit("update:visible", false)
    },

  },
};
</script>

<style lang="scss" scoped>
.search-popup {
  ::v-deep  .el-dialog {
    min-width: 1024px;
    height: 700px;
    background-color: #f2f2ed;
    border-radius: 3px !important;
    ::v-deep .el-dialog__header {
      height: 50px;
      ::v-deep .el-dialog__body {
        padding: 0px 24px 0px 19px;
      }
    }
  }
}

.search-popup .btn-create {
  width: 152px;
  height: 32px;
}

.flow{
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Inter;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0%;
}

.rightArrow{
  margin: 2px 16px;
}

.viewable-area-style ::v-deep .el-dialog {
  padding-top: 0px !important;
}
.header-style {
  margin-top: 34px;
  height: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
}

.m-r-16 {
  margin-right: 16px;
}
.title-style {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 24px;
  font-weight: 300;
  color: #525250;
}
.img-div {
  width: 410px;
  height: 229px;
  left: 542px;
  gap: 0px;
  border-radius: 8px 0px 0px 0px;
  border: 1px 0px 0px 0px;
  opacity: 0px;
}
</style>
